/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CatalogAddressAmbiguousModel { 
    compositeProductId: number;
    countryId: number;
    donorRowIds: Array<number>;
}

